import React from "react";
import numeral from "numeral";
import { Icon } from "shared";

const WardsMapTooltip = ({ objectToDisplay, pointerX, pointerY, onClose }) => {
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 3,
        left: pointerX,
        top: pointerY,
        ...styles.tooltipContainer,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span style={styles.title}>{objectToDisplay.name}</span>
        <Icon name="close" onClick={onClose} />
      </div>
      <br />
      <span style={styles.brandName}>
        Dân số:{" "}
        <span style={styles.number}>
          {numeral(objectToDisplay.population).format("0,0")} người
        </span>
      </span>
      <br />
      {objectToDisplay.area && (
        <span style={styles.brandName}>
          Diện tích:{" "}
          <span style={styles.number}>{objectToDisplay.area} km2</span>
        </span>
      )}
      <br />
      {objectToDisplay.area && (
        <span style={styles.brandName}>
          Mật độ dân số:{" "}
          <span style={styles.number}>
            {numeral(objectToDisplay.population / objectToDisplay.area).format(
              "0,0"
            )}{" "}
            người / km2
          </span>
        </span>
      )}
    </div>
  );
};

const styles = {
  tooltipContainer: {
    backgroundColor: "var(--color-white)",
    padding: 12,
    boxShadow: "0 2px 4px 0 rgba(0,0,0,.24)",
    borderRadius: 4,
  },
  title: {
    fontSize: 18,
    fontWeight: 500,
  },
  description: {
    fontSize: 14,
    whiteSpace: "pre-line",
  },
  brandName: {
    fontSize: 12,
  },
  address: {
    marginTop: 6,
    fontSize: 12,
  },
  number: {
    fontWeight: 700,
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
  },
};

export default WardsMapTooltip;
